/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiJMESPathExpressionTestType } from './InternalApiJMESPathExpressionTestType';
import {
    InternalApiJMESPathExpressionTestTypeFromJSON,
    InternalApiJMESPathExpressionTestTypeFromJSONTyped,
    InternalApiJMESPathExpressionTestTypeToJSON,
    InternalApiJMESPathExpressionTestTypeToJSONTyped,
} from './InternalApiJMESPathExpressionTestType';

/**
 * 
 * @export
 * @interface InternalApiJMESPathExpressionTestRequest
 */
export interface InternalApiJMESPathExpressionTestRequest {
    /**
     * 
     * @type {InternalApiJMESPathExpressionTestType}
     * @memberof InternalApiJMESPathExpressionTestRequest
     */
    testType: InternalApiJMESPathExpressionTestType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiJMESPathExpressionTestRequest
     */
    externalId: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiJMESPathExpressionTestRequest
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiJMESPathExpressionTestRequest
     */
    expression: string;
}



/**
 * Check if a given object implements the InternalApiJMESPathExpressionTestRequest interface.
 */
export function instanceOfInternalApiJMESPathExpressionTestRequest(value: object): value is InternalApiJMESPathExpressionTestRequest {
    if (!('testType' in value) || value['testType'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('expression' in value) || value['expression'] === undefined) return false;
    return true;
}

export function InternalApiJMESPathExpressionTestRequestFromJSON(json: any): InternalApiJMESPathExpressionTestRequest {
    return InternalApiJMESPathExpressionTestRequestFromJSONTyped(json, false);
}

export function InternalApiJMESPathExpressionTestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiJMESPathExpressionTestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'testType': InternalApiJMESPathExpressionTestTypeFromJSON(json['testType']),
        'externalId': json['externalId'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'expression': json['expression'],
    };
}

export function InternalApiJMESPathExpressionTestRequestToJSON(json: any): InternalApiJMESPathExpressionTestRequest {
    return InternalApiJMESPathExpressionTestRequestToJSONTyped(json, false);
}

export function InternalApiJMESPathExpressionTestRequestToJSONTyped(value?: InternalApiJMESPathExpressionTestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'testType': InternalApiJMESPathExpressionTestTypeToJSON(value['testType']),
        'externalId': value['externalId'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'expression': value['expression'],
    };
}

